import { FC } from 'react';

import { getDocumentIcon } from 'utils/documentIcons';
import { getFileDate } from 'utils/files';

type DocumentRowProps = {
  index: number;
  file: File;
  handleRemoveFile: (index: number) => void; // eslint-disable-line
};

const DocumentRow: FC<DocumentRowProps> = ({
  index,
  file,
  handleRemoveFile,
}) => {
  const fileIcon = getDocumentIcon(file, true);
  const fileDate = getFileDate(file);

  const handleRemove = () => {
    handleRemoveFile(index);
  };

  return (
    <div className="nk-file-item nk-file">
      <div className="nk-file-info">
        <div className="nk-file-title w-100">
          <div className="nk-file-icon">
            <span className="nk-file-icon-type">
              <img src={fileIcon} alt="icon-file" />
            </span>
          </div>

          <div className="nk-file-name">
            <div
              className="nk-file-name-text d-flex flex-column"
              style={{ maxWidth: '300px' }}
            >
              <span className="title text-ellipsis" title={file?.name}>
                {file?.name}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="nk-file-meta d-none d-xl-table-cell">
        <div className="tb-lead text-center">{fileDate}</div>
      </div>
      <div className="text-center">
        <button
          type="button"
          className="text-soft btn btn-icon"
          onClick={handleRemove}
        >
          <em className="icon ni ni-trash" />
        </button>
      </div>
    </div>
  );
};

export default DocumentRow;
